import { useEffect } from 'react';
import { motion } from 'framer-motion';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import teaching from '../../assets/class.jpg'
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { Skeleton } from "@material-ui/lab";

const Intro = ({ notices }) => {
    //console.log(notices)
    let match;
    if (notices) {      
        match = notices.filter((notice) => {
            return notice.audience === 'Public'
        });  
        
        console.log( notices, match)
    }
    window.addEventListener('resize', () => {
        if(window.innerWidth < 600) {
            $('.intro-cont').removeClass('section');
        } else {
            $('.intro-cont').addClass('section');
        }
    });
    useEffect(() => {
        if(window.innerWidth < 600) {
            $('.intro-cont').removeClass('section');
        }
    }, [])
    
    return ( 
            <div className="light-bg pt-3">
                <div className="section mt-4 mx-none mx-at-large intro-cont">
                    <div className="row intro">
                        <motion.div 
                            className="col s12 m6 l6 mb-5"
                            whileHover={{ scale: 1.05 }}
                        >
                            <div className="notices z-depth-1">
                                <div className="notices-header main-bg2 center py-1 smooth-edge-1">
                                    <p className="title py-4 make-inline-block white-text has-text-weight-semibold">Important Notices</p>
                                </div>
                                <div className="notices-body smooth-edge-1">
                                    {
                                        
                                        match ? (
                                            <>
                                                {
                                                    match.length !== 0 ? (
                                                        <>
                                                            {
                                                                match.slice(0, 3).map(notice => (
                                                                    <div className="notice px-3" key={notice.id}>
                                                                        <h5 className="has-text-weight-semibold is-size-4-touch is-size-5-desktop">{notice.topic}</h5>
                                                                        <p className="has-text-weight-light mb-3">{notice.body.slice(0, 45)}...</p>
                                                                        <Link to={`/notice/${notice.id}`} className="button is-small mb-4">
                                                                            <span>More</span>
                                                                            <span className="icon">
                                                                                <FaArrowRight className="grey-text"/>
                                                                            </span>
                                                                        </Link>
                                                                        <div className="divider mb-3"></div>
                                                                    </div>
                                                                ))
                                                            }

                                                        </>

                                                    ) : (
                                                        <>
                                                            <div className="px-4 py-4">
                                                                <Skeleton variant="text" />
                                                                <Skeleton variant="text" />
                                                                <Skeleton variant="text" />
                                                                <Skeleton variant="text" />
                                                                <Skeleton variant="rectangular" width="30%"/>
                                                            </div>
                                                            <div className="px-4 py-4">
                                                                <Skeleton variant="text" />
                                                                <Skeleton variant="text" />
                                                                <Skeleton variant="text" />
                                                                <Skeleton variant="text" />
                                                                <Skeleton variant="rectangular" width="30%"/>
                                                            </div>
                                                            <div className="px-4 py-4">
                                                                <Skeleton variant="text" />
                                                                <Skeleton variant="text" />
                                                                <Skeleton variant="text" />
                                                                <Skeleton variant="text" />
                                                                <Skeleton variant="rectangular" width="30%"/>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </>
                                        ) : (
                                            <Skeleton />
                                        )
                                       
                                    }
                                    
                                </div>
                            </div>
                        </motion.div>
                        {/* ========== ROW TWO ======== */}
                        <motion.div 
                            className="col s12 m6 l5 offset-l1"
                            whileHover={{ scale: 1.05 }}
                        
                        >
                            <div className="card">
                                <div className="card-image">
                                    <img src={teaching} alt="l"/>
                                </div>
                                <div className="card-content">
                                    <h5 className="subtitle has-text-weight-bold">We Offer Globally Recognised Qualifications</h5>
                                    <p className="is-size-6">Life Long Polytechnic is cofounded by <b>Educationists</b> par excellent Directors with vast training experience in <b>technical subjects</b> of the <b>HEXCO Curriculum</b>.</p>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
                      
     );
}
 
const mapStateToProps = (state) => {
    //console.log(state)
    return {
        notices: state.firestore.ordered.notices
    }
    
}

export default compose(
    connect(mapStateToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "notices", orderBy: ['postDate', 'desc']
            },
    ])
)(Intro);
